import { FLAG_SEARCH_INFINITE_SCROLL } from '@iconik-io/shared-lib/src/analytics/flags';
import { growthbook } from '@iconik-io/shared-lib/src/analytics/growthbook';
import type { CommonListGetConfig } from '@iconik-io/shared-lib/src/redux/common_list/thunks';

import { SHARE_COLLECTION_PAGE_ROUTE } from '../../../constants/routes';
import type { AppState } from '../../../store/types';
import {
  selectCanPageNaturalSearch,
  selectIsNaturalSearchActive,
} from '../../natural_search/selectors';

export const selectSearchPaginationType = (
  state: AppState,
): CommonListGetConfig['paginationType'] => {
  if (!(growthbook?.isOn(FLAG_SEARCH_INFINITE_SCROLL) ?? false)) {
    return 'regular';
  }
  // A natural answer's next page is a replay of it, asked for by number. One
  // that cannot page is the one page it answered with.
  if (selectIsNaturalSearchActive(state)) {
    return selectCanPageNaturalSearch(state) ? 'infinite' : 'regular';
  }
  return state.routeParams.route === SHARE_COLLECTION_PAGE_ROUTE
    ? 'infinite'
    : 'cursor';
};

export const selectIsSearchPagedByNumber = (state: AppState): boolean =>
  selectSearchPaginationType(state) === 'regular';
